import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { axiosGet } from "utils/APIHelper";
import { responseTypes } from "utils/Types";
import { Hall, LibraryHallState } from "./Hall";

const initialState: LibraryHallState = {
  list: [],
  status: "idle"
  //add error field
};

export const fetchFunctionalAreaAsync = createAsyncThunk("LibraryHall/functionalArea", async (data: {}, thunkApi) => {
  const API_URL = "functionalAreas";
  const { rejectWithValue } = thunkApi;
  const response: any = await axiosGet(API_URL);
  if (response.status !== responseTypes.success) {
    return rejectWithValue(response.response.data);
  }
  if (
    response?.response?.status >= responseTypes.internal_error &&
    response?.response?.status < responseTypes.other_error
  ) {
    return thunkApi.rejectWithValue(response.response);
  }
  return response.data.functionalAreas;
});

export const FunctionalAreaSlice = createSlice({
  name: "FunctionalAreas",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchFunctionalAreaAsync.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchFunctionalAreaAsync.fulfilled, (state, action: PayloadAction<Hall[]>) => {
        state.status = "idle";
        state.list = action.payload;
      })
      .addCase(fetchFunctionalAreaAsync.rejected, (state) => {
        state.status = "failed";
      });
  }
});

export default FunctionalAreaSlice.reducer;
